import React, { useState } from 'react';
import user from '../Assets/Company/photot.png';

const Company = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="min-h-screen bg-white text-blue-900 p-6">
      {/* Company Info Section */}
      <header className="text-center mb-12">
        <div className="flex flex-col items-center">
          <img
            src={user}
            alt="Company Logo"
            className="w-32 h-32 mb-4 rounded-full"
          />
          <h1 className="text-4xl font-bold">Company Name</h1>
          <p className="text-lg font-medium text-gray-600 mb-2">IT Consulting</p>
          <div className="flex items-center space-x-1 text-yellow-400 mb-4">
            {[...Array(5)].map((_, index) => (
              <span key={index}>&#9733;</span>
            ))}
          </div>
          <p className="mt-4 text-lg text-blue-700 max-w-2xl">
            Welcome to our company page! Learn more about our mission, vision, and explore the exciting career opportunities we have to offer.
          </p>
        </div>
      </header>

      {/* Navigation Bar */}
      <nav className="flex justify-center mb-8">
        <button
          onClick={() => handleTabClick('overview')}
          className={`px-4 py-2 mx-2 rounded ${
            activeTab === 'overview' ? 'bg-blue-600 text-white' : 'bg-blue-50 text-blue-900'
          } hover:bg-blue-700 hover:text-white transition-all`}
        >
          Overview
        </button>
        <button
          onClick={() => handleTabClick('jobs')}
          className={`px-4 py-2 mx-2 rounded ${
            activeTab === 'jobs' ? 'bg-blue-600 text-white' : 'bg-blue-50 text-blue-900'
          } hover:bg-blue-700 hover:text-white transition-all`}
        >
          Jobs
        </button>
      </nav>

      {/* Content Section */}
      <section className="max-w-5xl mx-auto">
        {activeTab === 'overview' && (
          <div className="text-center">
            <h2 className="text-3xl font-semibold mb-4">About Our Company</h2>
            <p className="text-blue-800 leading-relaxed mb-6">
              Our company is committed to innovation, growth, and delivering exceptional value to our customers.
              We pride ourselves on fostering a collaborative and inclusive work environment that empowers our team to achieve their best.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-left">
              <div>
                <h3 className="text-lg font-bold text-blue-600">Type</h3>
                <p className="text-gray-600">IT Consulting</p>
              </div>
              <div>
                <h3 className="text-lg font-bold text-blue-600">Founded In</h3>
                <p className="text-gray-600">2010</p>
              </div>
              <div>
                <h3 className="text-lg font-bold text-blue-600">Company Size</h3>
                <p className="text-gray-600">500-1000 employees</p>
              </div>
              <div>
                <h3 className="text-lg font-bold text-blue-600">Website</h3>
                <a href="https://companywebsite.com" className="text-blue-500 hover:underline">
                  https://companywebsite.com
                </a>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'jobs' && (
          <div>
            <h2 className="text-3xl font-semibold mb-8">Current Openings</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {/* Job Card 1 */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 shadow-md">
                <h3 className="text-2xl font-bold mb-2">Frontend Developer</h3>
                <p className="text-sm text-blue-600 mb-4">Location: Remote</p>
                <p className="text-blue-800 mb-6">
                  We are looking for a talented frontend developer to join our team and help us build amazing user experiences.
                </p>
                <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-all">
                  Apply Now
                </button>
              </div>

              {/* Job Card 2 */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 shadow-md">
                <h3 className="text-2xl font-bold mb-2">Backend Developer</h3>
                <p className="text-sm text-blue-600 mb-4">Location: New York, NY</p>
                <p className="text-blue-800 mb-6">
                  Join our backend team to develop robust and scalable server-side applications.
                </p>
                <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-all">
                  Apply Now
                </button>
              </div>

              {/* Job Card 3 */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 shadow-md">
                <h3 className="text-2xl font-bold mb-2">UI/UX Designer</h3>
                <p className="text-sm text-blue-600 mb-4">Location: San Francisco, CA</p>
                <p className="text-blue-800 mb-6">
                  Help us create intuitive and beautiful designs that delight our users.
                </p>
                <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-all">
                  Apply Now
                </button>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default Company;
